import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CatalogPromotion,
  CatalogPromotionInput,
  CatalogPromotionMutationResult,
  CatalogSectionSetting,
  CatalogSectionSettingInput,
  CatalogSectionSettingMutationResult,
} from '../models/catalog-marketing.models';
import { CatalogMarketingApiService } from '../data-access/catalog-marketing-api.service';

@Injectable()
export class CatalogMarketingService {
  constructor(private readonly api: CatalogMarketingApiService) {}

  settings(): Observable<CatalogSectionSetting[]> {
    return this.api.settings();
  }

  promotions(activeOnly: boolean | null = null): Observable<CatalogPromotion[]> {
    return this.api.promotions(activeOnly);
  }

  updateSetting(input: CatalogSectionSettingInput): Observable<CatalogSectionSettingMutationResult> {
    return this.api.updateSetting(input);
  }

  createPromotion(input: CatalogPromotionInput): Observable<CatalogPromotionMutationResult> {
    return this.api.createPromotion(input);
  }

  updatePromotion(
    id: string,
    input: CatalogPromotionInput
  ): Observable<CatalogPromotionMutationResult> {
    return this.api.updatePromotion(id, input);
  }

  destroyPromotion(id: string): Observable<CatalogPromotionMutationResult> {
    return this.api.destroyPromotion(id);
  }

  deactivatePromotion(id: string): Observable<CatalogPromotionMutationResult> {
    return this.api.destroyPromotion(id);
  }

  reactivatePromotion(id: string): Observable<CatalogPromotionMutationResult> {
    return this.api.updatePromotionActive(id, true);
  }

  permanentlyDeletePromotion(id: string): Observable<{ success: boolean; errors: string[] }> {
    return this.api.permanentlyDeletePromotion(id);
  }
}
